<template>
    <div>
        <video id="lemon_video" ref="videoPlayer" controls class="video-js vjs-big-play-centered"></video>
    </div>
</template>

<script>
import videojs from 'video.js'
// 不要忘记包括视频.js CSS，位于 .video.js/dist/video-js.css

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default () {
        return {
          autoplay: false,
          controls: true,
          muted: false,
          techOrder: ['html5', 'flash'],
          preload: 'metadata'
        }
      }
    }
  },
  data () {
    return {
      player: null
    }
  },
  mounted () {
    var that = this
    setTimeout(function () {
      that.player = videojs(that.$refs.videoPlayer, that.options, function onPlayerReady () {
        // console.log('onPlayerReady', this)
        that.player.pause()
      })
    }, 1000)
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
<style scoped>
    .video-js { width:740px !important; height:400px !important;}
</style>



// WEBPACK FOOTER //
// src/components/video/index.vue